import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ActionBar = ({
  onSubmit,
  next,
  disableNext = false,
  nextText = "Next",
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (next) {
      navigate(next);
    } else {
      onSubmit?.();
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        paddingTop: "8px",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          gap: "16px",
        }}
      >
        <div style={{ width: "100%" }} />
        <Button
          variant="contained"
          onClick={handleClick}
          disabled={disableNext}
          style={{ whiteSpace: "nowrap", textTransform: "none" }}
        >
          {nextText}
        </Button>
      </div>
    </div>
  );
};

export default ActionBar;
